// extracted by mini-css-extract-plugin
module.exports = {"base":"logo_base__Rlguc","imgWrapper":"logo_imgWrapper__gasdQ","text":"logo_text__FAfvy"};